var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 4.2967C1.33203 2.6627 2.68552 1.33203 4.34839 1.33203H7.65579C9.31526 1.33203 10.6654 2.6587 10.6654 4.29003V11.7007C10.6654 13.3354 9.31187 14.6654 7.64833 14.6654H4.34228C2.68213 14.6654 1.33203 13.3387 1.33203 11.7074V11.0807V4.2967Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5169 7.63409L12.6197 5.69476C12.4236 5.49476 12.108 5.49476 11.9126 5.69609C11.7178 5.89742 11.7185 6.22209 11.9139 6.42209L12.9534 7.48409H11.9568H6.36323C6.08728 7.48409 5.86328 7.71409 5.86328 7.99742C5.86328 8.28142 6.08728 8.51076 6.36323 8.51076H12.9534L11.9139 9.57276C11.7185 9.77276 11.7178 10.0974 11.9126 10.2988C12.0107 10.3994 12.1386 10.4501 12.2671 10.4501C12.3944 10.4501 12.5223 10.3994 12.6197 10.3001L14.5169 8.36142C14.611 8.26476 14.6643 8.13409 14.6643 7.99742C14.6643 7.86142 14.611 7.73076 14.5169 7.63409Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.aa365149db5b0990c48242be80a625b9.svg";
export { ForwardRef as ReactComponent };